import { AnimatePresence } from "framer-motion"
import Text from "../../../../core/utils/Text"
import { CFlex, DeleteIcon, DText, Flex, IconWrapper } from "../../../../styles/CommonStyles"
import { AddIcon, EditIcon, ModeDecoration } from "../../../../styles/main/setting"
import Select from "../../../common/dropdown/Select"
import Tooltip from "../../../common/utils/Tooltip"
import ListLayout from "../../../layout/main/ListLayout"
import ModalLayout from "../../../layout/main/ModalLayout"
import SettingCard from "../../../layout/main/SettingCard"
import BasicModal from "../../../modals/BasicModal"
import SubmitModal from "../../../modals/SubmitSettingModal"
import DetailBox from "./details/DetailBox"
import NetworkBox from "./details/NetworkBox"
import DetailUpdate from "./updates/DetailUpdate"
import NetworkUpdate from "./updates/NetworkUpdate"
import TransferUpdate from "../common/TransferUpdate"
import useCurrencySetting, {AC_SETTING_TYPES} from "../../../../core/hooks/main/setting/currencies/useCurrencySetting";
import TransferBox from "../common/TransferBox";
import SwapUpdate from "../common/SwapUpdate";
import SwapBox from "../common/SwapBox";



const AvailableCoinsDetail = ({
    data,
    coinState
}) => {

    const { data: currencies } = data

    const {
        editState,
        coin,
        onCoinChange,
        editMode,
        enterEditMode,
        exitEditMode,
        onDetailChange,
        onAddNetwork,
        onDeleteNetwork,
        onSubmitChanges,
        loading,
        onDeleteAvailableCoin,
        deleteModal,
        onDeleteModalClose,
        onDeleteModalOpen
    } = useCurrencySetting(currencies, coinState)


    return (
        <>
            <ListLayout>
                <CFlex fw>
                    <Flex fw justify='flex-end'>
                        <ModeDecoration />
                        <DText main fontSize='s'>
                            <Text tid='mode' /> :
                        </DText>
                        <DText main style={{ margin: '0 4px' }} fontSize='s'>
                            <Text tid={`${editMode}-mode`} />
                        </DText>
                    </Flex>
                    <SettingCard
                        minHeight='0'
                        noTitle
                        main
                    >
                        <Flex fw justify='space-between'>
                            <Select
                                options={currencies}
                                value={coin}
                                onValueChange={onCoinChange}
                                placeHolder={'select-coin'}
                                width={'240px'}
                                height={'42px'}
                                isCoin
                            />
                            <Flex>
                                <Tooltip
                                    content='add-coin'
                                >
                                    <IconWrapper
                                        onClick={() => enterEditMode('add')}
                                    >
                                        <AddIcon size={24} />
                                    </IconWrapper>
                                </Tooltip>
                                <Tooltip
                                    content='edit'
                                >
                                    <IconWrapper
                                        onClick={() => enterEditMode(AC_SETTING_TYPES.ALL)}
                                    >
                                        <EditIcon size={24} />
                                    </IconWrapper>
                                </Tooltip>
                                {coin &&
                                    <Tooltip
                                        content='delete'
                                    >
                                        <IconWrapper
                                            onClick={onDeleteModalOpen}
                                        >
                                            <DeleteIcon size={24} />
                                        </IconWrapper>
                                    </Tooltip>
                                }

                            </Flex>
                        </Flex>
                    </SettingCard>

                    {/* details */}
                    <SettingCard
                        title='details'
                        coin={coin}
                        onEditClicked={() => enterEditMode(AC_SETTING_TYPES.DETAILS)}
                        minHeight={'0'}
                    >
                        <AnimatePresence exitBeforeEnter>
                            {editState[AC_SETTING_TYPES.DETAILS] ?
                                <DetailUpdate
                                    coin={coin}
                                    onDetailChange={onDetailChange}
                                />
                                :
                                <DetailBox
                                    coin={coin}
                                />
                            }
                        </AnimatePresence>
                    </SettingCard>


                    <Flex fw wrap justify='space-between' align={'stretch'}>
                        {/* transfer */}
                        <SettingCard
                            width='48%'
                            title='transfer'
                            coin={coin}
                            onEditClicked={() => enterEditMode(AC_SETTING_TYPES.TRANSFER)}
                        >
                            <AnimatePresence exitBeforeEnter>
                                {editState[AC_SETTING_TYPES.TRANSFER] ?
                                    <TransferUpdate
                                        detail={coin?.transfer}
                                        type={'transfer'}
                                        onDetailChange={onDetailChange}
                                        currency={coin?.currency}
                                    />
                                    :
                                    <TransferBox
                                        detail={coin?.transfer}
                                        currency={coin?.currency}
                                    />
                                }
                            </AnimatePresence>
                        </SettingCard>

                        {/* swap */}
                        <SettingCard
                            width='48%'
                            title='swap'
                            coin={coin}
                            onEditClicked={() => enterEditMode(AC_SETTING_TYPES.SWAP)}
                        >
                            {editState[AC_SETTING_TYPES.SWAP] ?
                                <SwapUpdate
                                    detail={coin?.swap}
                                    type='swap'
                                    onDetailChange={onDetailChange}
                                    currency={coin?.currency}
                                />
                                :
                                <SwapBox
                                    detail={coin?.swap}
                                    currency={coin?.currency}
                                />
                            }
                        </SettingCard>
                    </Flex>

                    {/*/!* withdraw list - deposit list *!/*/}
                    <SettingCard
                        title='deposit-withdraw-fee'
                        coin={coin}
                        onEditClicked={() => enterEditMode(AC_SETTING_TYPES.DEPOSIT_WITHDRAW)}
                    >
                        {editState[AC_SETTING_TYPES.DEPOSIT_WITHDRAW] ?
                            <NetworkUpdate
                                coin={coin?.wallet}
                                onDetailChange={onDetailChange}
                                onAddNetwork={onAddNetwork}
                                onDeleteNetwork={onDeleteNetwork}
                            />
                            :
                            <NetworkBox
                                coin={coin?.wallet}
                            />
                        }
                    </SettingCard>
                </CFlex>

                <ModalLayout
                    onClose={onDeleteModalClose}
                    open={deleteModal}
                    width={'520px'}
                >
                    <BasicModal
                        onClose={onDeleteModalClose}
                        _id={deleteModal.token?._id}
                        loading={loading}
                        head={'delete-available-coin-head'}
                        desc={'delete-available-coin-desc'}
                        onSubmit={onDeleteAvailableCoin}
                    />
                </ModalLayout>

            </ListLayout>
            <SubmitModal
                editMode={editMode !== 'close'}
                onSubmit={onSubmitChanges}
                onCancel={exitEditMode}
                loading={loading}
            />

        </>

    )
}


export default AvailableCoinsDetail
